import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { MapPolygon } from "../interfaces/map-polygon";

export const polygonControl = () => {
    const polygon = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
            polygon: true,
            trash: true
        }
    });

    return polygon;
}

export const drawPolygon = (map: mapboxgl.Map, polygon: MapPolygon) => {
    const sourceId = polygon.identification + '-polygon';
    const layerShapeId = polygon.identification + '-polygon-shape';
    const layerOutlineId = polygon.identification + '-polygon-outline';

    map.addSource(sourceId,
    {
        'type': 'geojson',
        'data': {
            'type': 'FeatureCollection',
            'features': [
                {
                    'type': 'Feature',
                    'geometry': {
                        'type': 'Polygon',
                        'properties': {},
                        'coordinates': polygon.coordinates
                    }
                }
            ]
        } as any
    });

    map.addLayer({
        'id': layerShapeId,
        'type': 'fill',
        'source': sourceId,
        'layout': {},
        'paint': {
            'fill-color': '#00ac11',
            'fill-opacity': 0.15
        }
    });

    map.addLayer({
        'id': layerOutlineId,
        'type': 'line',
        'source': sourceId,
        'layout': {},
        'paint': {
            'line-color': '#00ac11',
            'line-width': 2
        }
    });
}


export const delelePolygon = (map: mapboxgl.Map, identification: string) => {
    const sourceId = identification + '-polygon';
    const layerShapeId = identification + '-polygon-shape';
    const layerOutlineId = identification + '-polygon-outline';

    if (map.getLayer(layerShapeId)) {
        map.removeLayer(layerShapeId);
    }

    if (map.getLayer(layerOutlineId)) {
        map.removeLayer(layerOutlineId);
    }

    if (map.getSource(sourceId)) {
        map.removeSource(sourceId);
    }
}
